import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { pxToRem } from '../../spacing/utils.js';
import { themeGet } from '../../theme/themeGet/get.js';

var DEFAULT_ICON_SIZE = 16;
var StyledFontAwesomeIcon = styled(FontAwesomeIcon).withConfig({
  displayName: "StyledFontAwesomeIcon",
  componentId: "sc-1yt88g4-0"
})(["width:", ";height:", ";color:", ";"], function (_ref) {
  var _ref$$size = _ref.$size,
    $size = _ref$$size === void 0 ? DEFAULT_ICON_SIZE : _ref$$size;
  return pxToRem($size);
}, function (_ref2) {
  var _ref2$$size = _ref2.$size,
    $size = _ref2$$size === void 0 ? DEFAULT_ICON_SIZE : _ref2$$size;
  return pxToRem($size);
}, function (_ref3) {
  var _ref3$$color = _ref3.$color,
    $color = _ref3$$color === void 0 ? 'gray.1000' : _ref3$$color;
  return themeGet("colors." + $color);
});

export { StyledFontAwesomeIcon };
